import React, { Component } from 'react'
import { DetailContainer } from '../DetailContainer';
import { connect } from 'react-redux';
import Loading from '../../apa/components/Loading';
import autobind from 'autobind-decorator';
import { ListGroup, Input, Label, Button, InputGroup, InputGroupAddon} from 'reactstrap';
import ReportPrintButton from './ReportPrintButton';
import { ReportCategory } from './ReportCategory';
import {ReportSearch} from 'customers/reports/ReportSearch';
import Select from 'react-select';
import { BaseUrl } from '../../BaseUrl/BaseUrl';

@connect(
	state => (
		{
			auth: state.apa
		}
	)
)
export default class ReportDetails extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			report: null,
			searchText: ''
		}
	}

	componentDidMount() {
		this.loadReport()
	}

	@autobind
	loadReport() {
		this.setState({isLoading: true})
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const id = this.props.match.params.report_id;
		fetch(
			`${BaseUrl}/api/reports/${id}/`,
			{ headers }
		)
			.then(res => res.json())
			.then(
				report => {
					this.setState(
						{
							isLoading: false,
							report: report
						}
					)
				}
			)
	}

	@autobind
	addCategory(option) {
		const value = option.value;
		this.setState({
			isLoading: true,
		})
		if (!value)
			return;
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Token ${this.props.auth.token}`
		};
		const id = this.props.match.params.report_id;
		const categoryList = this.state.report.categories.map(
			category => category.id
		)
		categoryList.push(value)
		const body = JSON.stringify(
			{
				categories: categoryList
			}
		)
		fetch(
			`${BaseUrl}/api/reports/${id}/`,
			{ headers, method: 'PATCH', body }
		).then(
			res => res.json()
		).then(
			() => {
				this.loadReport()
			}
		)
	}

	@autobind
	search(e) {
		if(!e) {
			this.setState({
				searchText: ''
			})
			this.loadReport()
			return;
		}
		const value = e.target.value;
		if(value === '') {
			this.loadReport()
		}
		this.setState({
			searchText: value
		})
	}


	render() {
		const reportId = this.props.match.params.report_id;
		const customerId = this.props.match.params.id;
		const report = this.state.report;
		if (this.state.isLoading) {
			return <Loading />
		}


		const measureList = []
		this.state.report.categories.map(
			category =>
				category.children.map(
					subcat => subcat.checkpoints.map(
						checkpoint => checkpoint.measures.map(
							measure => {
								if(measure.name.toLowerCase().indexOf(this.state.searchText.toLowerCase()) > -1) {
									measureList.push(measure)
								}
							}
						)
					)
				)
		)

		return (
			<DetailContainer id={customerId}>
				<h1>{report.customer_name}</h1>
				<ReportPrintButton customerId={customerId} reportId={reportId} />
				<p>{report.name} {report.sector}</p>
				<Label>
					Neue Kategorie hinzufügen
				</Label>
				<Select
                    onChange={this.addCategory}
					options={
						report.all_categories.map(
							category => (
								{
									value: category.id,
									label: category.name
								}
							)
						)
					}
				/>
				<br/>
				<InputGroup>
					<Input placeholder='Suche' onChange={this.search} value={this.state.searchText} />
					<InputGroupAddon addonType='append'>
						<Button color='primary' onClick={() => this.search(null)}>Zurücksetzen</Button>
					</InputGroupAddon>
				</InputGroup>
                <br/>

				{ !this.state.searchText &&
					<ListGroup>
						{
							this.state.report.categories.map(
								(category, index) =>
									<ReportCategory index={index} report={report} category={category} key={`report_category_${index}`} />
							)
						}
					</ListGroup>
				}
				{
					this.state.searchText &&
                        <ReportSearch
							report={report}
							measureList={measureList}
							/>
				}
			</DetailContainer>
		)
	}
}
